module.exports = __webpack_public_path__ + "static/media/15011.632e5b2a.jpeg";